import { View } from 'react-native';
export const NativeSearchBar = View;
export const NativeSearchBarCommands = View;
export default View;
//# sourceMappingURL=SearchBar.web.js.map